import { ByteArray } from '@awayjs/core';
var Part = /** @class */ (function () {
    function Part(name, version) {
        if (name === void 0) { name = null; }
        if (version === void 0) { version = null; }
        this.name = '';
        this.version = 0;
        this.native = {};
        this.name = name;
        this.version = version;
        this.data = new ByteArray();
    }
    return Part;
}());
export { Part };
